//My Imports
import * as types from './types';

export const addToCart = (product, count, weight) => async (dispatch, getState) => {

    try {

        //Create Product Data
        product = {
            id: product.id,
            thumbnailImgURL: product.thumbnailImgURL,
            title: product.title,
            price: getPrice(product, weight.toString()),
            bulkSale: product.bulkSale,
        }

        //Get Carts items from redux State
        //let reduxCartItems = getState().cart.reduxCartItems.slice();
        let reduxCartItems = JSON.parse(localStorage.getItem("localStoragecartItems") || "[]").slice();

        //Search & Update
        let alreadyExists = false
        reduxCartItems.forEach((x) => {
            if (x.id === product.id) {
                alreadyExists = true
                if (x.bulkSale) {
                    x.count = count
                    x.weight = weight
                    x.price = product.price
                }
                else { x.count += count; }
                x.totalPrice = x.price * x.count
                return
            }
        });

        //Add new
        if (!alreadyExists) {
            reduxCartItems.push({ ...product, count: count, weight: weight, totalPrice: product.price * count });
        }

        //Update Redux Cart State
        dispatch({
            type: types.ADD_TO_CART_REQUEST_SUCCESS,
            payload: { reduxCartItems },
        });

        //Update User LocalStorage
        localStorage.setItem("localStoragecartItems", JSON.stringify(reduxCartItems));


    } catch (error) {

        const err = error.response && error.response.data.message
            ? error.response.data.message
            : error.message

        console.log(err)

        dispatch({
            type: types.ADD_TO_CART_REQUEST_SERVER_ERROR,
        })

    }

};

export const removeFromCart = (id) => (dispatch, getState) => {

    try {
        //const reduxCartItems = getState().cart.reduxCartItems.slice().filter((x) => x.id !== id);
        let reduxCartItems = JSON.parse(localStorage.getItem("localStoragecartItems") || "[]").slice().filter((x) => x.id !== id);
        dispatch({ type: types.REMOVE_FROM_CART_SUCCESS, payload: { reduxCartItems } });
        localStorage.setItem("localStoragecartItems", JSON.stringify(reduxCartItems));

    } catch (error) {

        const err = error.response && error.response.data.message
            ? error.response.data.message
            : error.message

        console.log(err)

        dispatch({
            type: types.REMOVE_FROM_CART_ERROR,
        })

    }

};

export const getPrice = (product, weight) => {
    if (product.bulkSale) {
        if (weight === '1') return product.price250
        else if (weight === '2') return product.price500
        else if (weight === '4') return product.price1000
    }
    else
        return product.price250
}

//Morshed :|

// export const saveShippingAddress = (data) => (dispatch) => {
//     dispatch({
//         type: CART_SAVE_SHIPPING_ADDRESS,
//         payload: data,
//     })

//     localStorage.setItem('shippingAddress', JSON.stringify(data))
// }

// export const savePaymentMethod = (data) => (dispatch) => {
//     dispatch({
//         type: CART_SAVE_PAYMENT_METHOD,
//         payload: data,
//     })

//     localStorage.setItem('paymentMethod', JSON.stringify(data))
// }